/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { FC } from 'react';
import styles from './dataBim.module.scss';
import { ObraBim } from '../../../../types/ObraDetails';
import { useTranslation } from 'react-i18next';
import InfoBoxFooter from './components/InfoBoxFooter/InfoBoxFooter';
import { CATEGORY_COLORS, LEVEL_BAR_COLORS, LEVEL_COLORS } from '../colorSchema';
import InfoBoxBar from './components/InfoBoxBar/InfoBoxBar';
import InfoBoxBoolean from './components/InfoBoxBoolean/InfoBoxBoolean';




interface DataBimProps {
  bim: ObraBim
}

const DataBim: FC<DataBimProps> = (props) => {
  const { bim } = props;
  const [t] = useTranslation();

  const getLevel = (note: number) => {
    if (note < 3) {
      return 0;
    }
    else if (note >= 3 && note < 5) {
      return 1;
    }
    else if (note >= 5 && note < 7) {
      return 2;
    }
    else if (note >= 7 && note < 9) {
      return 3;
    }
    else if (note >= 9) {
      return 4;
    }
    return 2;
  };

  const getRequirement = () => {
    switch (bim.requisitos?.toString()) {
      case '6':
      case '7':
        return t('details.bim.acciona');
      case '4':
      case '5':
        return t('details.bim.client');
      default:
        return t('details.bim.clientAcciona');
    }
  };

  const toFixed = (value: string | number | null | undefined, fix: number) => {
    // if (typeof value === 'string') {
    //   //value = parseFloat(value);
    // }
    value = Number(value).toLocaleString('es-ES', { maximumFractionDigits: fix, useGrouping: true });
    return value;//.toFixed(fix).replace('.',',');
  };

  return (
    <div
      data-testid="data-bim-test"
      className={styles.dataBimContainer}>

      <div className={styles.box}>
        <div className={styles.boxContainerLeft}>
          <InfoBoxFooter
            identifier='notaGlobal'
            item={{ title: t('details.bim.globalNote'), value: toFixed(bim.notaGlobal, 2) }}
            footer={`${t('details.bim.globalFooter')}  ${bim.madurez?.descripcion}`}
            style={LEVEL_COLORS[bim.madurez?.codigo]}
          />
          <InfoBoxFooter
            identifier='categorizacion'
            item={{ title: t('details.bim.category'), value: bim.categorizacion?.descripcion }}
            footer={t('details.bim.categoryFooter')}
            style={CATEGORY_COLORS[bim.categorizacion?.descripcion]}
          />
        </div>
        <div className={styles.boxContainerRight}>
          <div className={styles.upperBoxes}>
            <InfoBoxBoolean
              identifier='requisitos'
              item={{ title: t('details.bim.requirements'), value: getRequirement() }}
              value={!!bim.requisitos}
            />
            <InfoBoxBoolean
              identifier='cde'
              item={{ title: t('details.bim.cde'), value: bim.cde ? t('details.bim.yes') : t('details.bim.no') }}
              value={bim.cde}
            />
          </div>
          <div className={styles.lowerBoxes}>
            <InfoBoxBar
              identifier='notaUsosBim'
              item={{ title: t('details.bim.bimUsesNote'), value: toFixed(bim.notaUsosBIM, 2) }}
              style={LEVEL_BAR_COLORS[getLevel(bim.notaUsosBIM)]}
              level={bim.notaUsosBIM || 0.5}
            />
            <InfoBoxBar
              identifier='notaUsosGestion'
              item={{ title: t('details.bim.managementUsesNote'), value: toFixed(bim.notaUsosGestion, 2) }}
              style={LEVEL_BAR_COLORS[getLevel(bim.notaUsosGestion)]}
              level={bim.notaUsosGestion || 0.5}
            />
            <InfoBoxBar
              identifier='notaUsosEstandarizacion'
              item={{ title: t('details.bim.standardizationUsesNote'), value: toFixed(bim.notaUsosEstandarizacion, 2) }}
              style={LEVEL_BAR_COLORS[getLevel(bim.notaUsosEstandarizacion)]}
              level={bim.notaUsosEstandarizacion || 0.5}

            />
          </div>
        </div>
      </div>

    </div>);
};

export default DataBim;
